import React from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import { BrowserRouter as Router,Navigate, Route, Routes } from 'react-router-dom';
import HomePage from "./pages/HomePage/HomePage";
import Arrebeef from "./pages/Arrebeef/Arrebeef"
import ArrebeefEN from "./pages/Arrebeef/ArrebeefEN"
import Cauchari from "./pages/Cauchari/Cauchari"
import Cafayate from "./pages/Cafayate/Cafayate"
import Helios from "./pages/Helios/Helios"
import Performancect from "./pages/Performancect/Performancect"
import MatrixHome from "./components/Matrix/MatrixHome";
import Cauchari_lite from "./pages/Cauchari/CauchariLite";
import MatrixCategoryPage from "./components/Matrix/MatrixCategoryPage";
import DigitalLogbook from "./pages/DigitalLogbook/DigitalLogbook";
import Indisponibilidades from "./pages/Unavailabilities/Indisponibilidades";
import AdminRoles from "./pages/Admin/AdminRoles";
import "./App.css";
import GU from "./pages/GU/GU";

//
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/cauchari" element={<Cauchari />} />
        <Route path="/cauchari_lite" element={<Cauchari_lite />} />
        <Route path="/arrebeef" element={<Arrebeef />} />
        <Route path="/arrebeef_en" element={<ArrebeefEN />} />
        <Route path="/demo" element={<Cafayate />} />
        <Route path="/helios" element={<Helios />} />
        <Route path="/gu" element={<GU />} />
        <Route path="/performancect" element={<Performancect />} />
        <Route path="/cauchari_cna" element={<MatrixHome />} />
        <Route path="/cauchari_cna/:category" element={<MatrixCategoryPage />} />
        <Route path="/pt8" element={<DigitalLogbook />} />
        <Route path="/indisponibilidades" element={<Indisponibilidades />} />
        <Route path="/usuarios" element={<AdminRoles />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
